import React, { Component } from 'react';
import moment from 'moment';
import { replaceBucketKeysWithUrls } from '@shootsta/client-aws-s3';
import SVG from 'react-inlinesvg';
import { Icon, Text, Dropdown, Image } from '../../../../ui-kit';
import { InsightsError } from '../../../../assets/images';

import { getRegionalMoment } from '../../../../common/utils';
import './styles/_leaderboard.scss';




























export const FILTERS_ENUM = Object.freeze({
  TODAY: 'TODAY',
  LAST_MONTH: 'LAST_MONTH',
  ALL_TIME: 'ALL_TIME'
});

const FILTER_OPTION_TO_CREATED_AT = {};

const DEFAULT_FILTERS = [
{ id: FILTERS_ENUM.TODAY, label: 'Today' },
{ id: FILTERS_ENUM.LAST_MONTH, label: 'This Month' },
{ id: FILTERS_ENUM.ALL_TIME, label: 'All Time' }];


export default class Leaderboard extends Component


{
  static defaultProps = {
    filters: DEFAULT_FILTERS
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedFilter: FILTERS_ENUM.LAST_MONTH,
      racetrackData: [],
      userData: [],
      errorFetching: false,
      imageUrls: []
    };

    const { billingEntityCode } = this.props;

    const startOfDay = getRegionalMoment(
      billingEntityCode,
      moment.utc().startOf('day')
    ) || moment.utc().startOf('day');

    const startOfMonth = getRegionalMoment(
      billingEntityCode,
      moment.utc().startOf('month')
    ) || moment.utc().startOf('month');

    FILTER_OPTION_TO_CREATED_AT[FILTERS_ENUM.TODAY] = startOfDay.toISOString();
    FILTER_OPTION_TO_CREATED_AT[FILTERS_ENUM.LAST_MONTH] = startOfMonth.toISOString();
    FILTER_OPTION_TO_CREATED_AT[FILTERS_ENUM.ALL_TIME] = moment(0).toISOString();
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedFilter } = this.state;

    if (prevState.selectedFilter !== selectedFilter) {
      this.fetchData();
    }
  }

  fetchData = async () => {
    const {
      getRacetrackAnalytics,
      organisationId,
      orderBy,
      orderByDirection
    } = this.props;

    const { selectedFilter } = this.state;
    const createdAt = [FILTER_OPTION_TO_CREATED_AT[selectedFilter]];

    if (getRacetrackAnalytics) {
      const { data, errors } = await getRacetrackAnalytics({
        createdAt,
        organisationId,
        orderBy,
        orderByDirection
      });

      if (
      errors ||
      !data ||
      !data.getRacetrackAnalytics ||
      !data.getRacetrackAnalytics.racetrackData ||
      !data.getRacetrackAnalytics.userData)
      {
        this.setState({ errorFetching: true });
        return;
      }

      const { racetrackData } = data.getRacetrackAnalytics;
      const { userData } = data.getRacetrackAnalytics;

      this.setState({
        racetrackData,
        userData,
        errorFetching: false
      });

      const allData = this.combineData(racetrackData, userData);

      const imageUrlArray = [];
      for (const dataItem of allData) {
        if (!dataItem.imageUrl) {
          imageUrlArray.push('');
        } else {
          /* eslint-disable no-await-in-loop */
          const preSignedUrl = await this.getPreSignedImageUrl(dataItem.imageUrl);
          imageUrlArray.push(preSignedUrl);
        }
      }

      this.setState({ imageUrls: imageUrlArray });

      return;
    }

    this.setState({ errorFetching: true });
  };

  combineData = (racetrackData, userData) => {
    if (userData.length <= 0) return racetrackData;

    const userIsInRacetrack = racetrackData.some(
      (item) => item.createdByUserId === userData[0].createdByUserId
    );

    if (userIsInRacetrack) return racetrackData;

    const userIndex = Math.max(...racetrackData.map((item, index) =>
    item.numberOfVideos > userData[0].numberOfVideos ?
    index + 1 :
    0
    ));

    return racetrackData.splice(userIndex, 0, userData[0]);
  };

  getInitials = (firstName, lastName) => {
    const firstInitial = firstName.length ? firstName.charAt(0).toUpperCase() : '-';
    const secondInitial = lastName.length ? lastName.charAt(0).toUpperCase() : '-';
    return `${firstInitial}${secondInitial}`;
  };

  getPreSignedImageUrl = async (imageUrl) => {
    const { organisationId, apolloClient } = this.props;

    try {
      const { imageUrl: preSignedImageUrl } = await replaceBucketKeysWithUrls({
        apiClient: apolloClient,
        data: { imageUrl },
        substitutedKeys: ['imageUrl'],
        organisationId
      });

      return preSignedImageUrl;
    } catch {

      // Silently handle error
    }
    return null;
  };

  createLeadersIcon = (crownColor, size, item, index) => {
    const { imageUrls } = this.state;

    return (
      <>
        <Icon
          name="master"
          size={20}
          color={crownColor} />

        <div className="leaderboard__main__top-three__item__icon-holder" style={{ position: 'relative' }}>
          <div className="leaderboard__main__top-three__item__icon-holder__icon">
            <Image
              width={size}
              height={size}
              imageUrl={imageUrls[index]}
              circular
              placeholderText={`${item.firstName} ${item.lastName}`}
              placeholderTextSize={16} />

          </div>
        </div>
        <Text ellipsisOverflow>
          {item.firstName || '-'}
        </Text>
        <div className="leaderboard__main__top-three__item__stats">
          {item.numberOfVideos || '-'}
          &nbsp;&nbsp;&nbsp;
          <Icon
            name="extrafootage"
            size={18} />

        </div>
      </>);

  };

  render() {
    const {
      filters
    } = this.props;

    const {
      racetrackData,
      userData,
      errorFetching,
      imageUrls
    } = this.state;

    const filterOptions = filters ? filters.map(({ label, id }) => (
    { label, value: id })
    ) : [];

    const allData = this.combineData(racetrackData, userData);


    return (
      <div className="leaderboard">
        <div className="leaderboard__header">
          <div className="leaderboard__filters-list">
            <Dropdown
              defaultValue={filterOptions.length > 1 ? filterOptions[1] : ''}
              options={filterOptions}
              onChange={(newValue) => this.setState({ selectedFilter: newValue.value })}
              type="BUTTON" />

          </div>
        </div>
        {errorFetching ?
        <div className="error-board">
            <SVG cacheRequests src={InsightsError} uniquifyIDs />
            <Text heading5>
              We&apos;re having difficulty displaying your leaderboard...
            </Text>
            <Text heading6>
              Try refreshing the page or if the problem persists contact support
            </Text>
          </div> :

        <div className="leaderboard__main">
            {allData.length > 0 &&
          <>
                <div className="leaderboard__main__top-three">
                  <div className="leaderboard__main__top-three__item">
                    {allData.length >= 2 &&
                <>
                        {this.createLeadersIcon('dusty', 65, allData[1], 1)}
                      </>}

                  </div>
                  <div className="leaderboard__main__top-three__item first-place">
                    {this.createLeadersIcon('goldenShiny', 80, allData[0], 0)}
                  </div>
                  <div className="leaderboard__main__top-three__item">
                    {allData.length >= 3 &&
                <>
                        {this.createLeadersIcon('unsafeOchre', 65, allData[2], 2)}
                      </>}

                  </div>
                </div>
                <hr />
                {allData.length >= 3 && allData.map((item, index) => index >= 3 ?
            <div className="leaderboard__main__list__item">
                    <div className="leaderboard__main__list__item__index">
                      {index + 1}
                      .
                    </div>
                    <div className="leaderboard__main__list__item__name">
                      <div className="leaderboard__main__list__item__name__icon">
                        <div className="leaderboard__main__list__item__name__icon__user-icon">
                          {this.getInitials(item.firstName, item.lastName)}
                        </div>
                        {imageUrls.length >= index && imageUrls[index] &&
                  <Image
                    width={35}
                    height={35}
                    imageUrl={imageUrls[index]}
                    circular
                    placeholderText={this.getInitials(item.firstName, item.lastName)}
                    placeholderTextSize={12} />}


                      </div>
                      <div className="leaderboard__main__list__item__name__name-text">
                        {`${item.firstName || '-'} ${item.lastName || '-'}`}
                      </div>
                    </div>
                    <div className="leaderboard__main__list__item__arrow">
                      <div className="leaderboard__main__list__item__arrow__text">
                        {item.numberOfVideos || '-'}
                      </div>
                      <Icon
                  name="extrafootage"
                  size={20} />

                    </div>
                  </div> :
            null)}
                {/* Data:
              {allData.map((item, index) => (
               <>
                 <br />
                 {index}
                 <br />
                 {JSON.stringify(item)}
               </>
              ))} */}
              </>}

          </div>}

      </div>);

  }
}